var exports = {
  "PJ": "ChannelLayout.module__channelLayoutContainer___QkZ2ek",
  "Ei": "ChannelLayout.module__channelNotFoundContainer___QkZ2ek",
  "Ck": "ChannelLayout.module__channelNotFoundContent___QkZ2ek",
  "I8": "ChannelLayout.module__channelNotFoundIcon___QkZ2ek",
  "lV": "ChannelLayout.module__channelNotFoundTitle___QkZ2ek",
  "f2": "ChannelLayout.module__channelNotFoundDescription___QkZ2ek",
};

module.exports = exports;
